export enum SubtaskStatus {
  NotStarted = 1,
  InProgress = 2,
  Completed = 3,
}

export const subtaskStatusLabels: Record<number, string> = {
  [SubtaskStatus.NotStarted]: 'notStarted',
  [SubtaskStatus.InProgress]: 'inProgress',
  [SubtaskStatus.Completed]: 'completed',
};
